var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V256H496V16Z",
    fill: "#E32D3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 256H16V496H496V256Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.981 47.7027C132.988 48.424 92.4326 87.0694 91.9187 135.078V135.984C91.9187 184.405 132.766 223.802 183.481 224.296C184.815 224.309 186.129 224.305 187.45 224.265C147.011 219.322 115.637 181.856 115.637 136.484V135.609C116.085 87.8202 151.224 49.2968 194.669 48.2339C191.612 47.9124 188.496 47.7333 185.356 47.7027C184.558 47.6947 183.775 47.6912 182.981 47.7027V47.7027Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.753 158.034L170.051 146.025L155.837 159.344L162.406 140.699L145.346 131.297L165.108 131.783L168.779 112.653L174.424 131.598L193.752 129.177L177.478 140.4L185.753 158.034Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.731 158.034L276.428 145.225L261.815 159.344L269.268 140.832L251.324 131.297L271.233 132.665L274.757 112.653L279.608 132.01L299.73 129.177L282.819 139.773L291.731 158.034Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M206.392 207.915L191.089 195.106L176.475 209.225L183.928 190.713L165.984 181.178L185.893 182.546L189.417 162.533L194.268 181.891L214.39 179.058L197.479 189.653L206.392 207.915Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M271.093 207.915L255.79 195.906L241.176 209.225L247.869 190.961L230.686 181.178L250.124 181.899L254.119 162.533L259.44 181.244L279.091 179.058L262.942 189.901L271.093 207.915Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M238.742 108.155L223.84 96.9463L208.826 109.465L214.881 91.8284L198.335 81.4181L216.98 81.7267L221.768 62.7737L227.236 80.6014L246.741 79.2982L231.475 90.0077L238.742 108.155Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/SG.a40a2a995fe834ee3ca03216c5883adb.svg";
export { ForwardRef as ReactComponent };